import type { ShelfOfPresetVideos } from "~/components/blocks/vod/top/common/shelf/type";
import { G_VideoShelfImageType } from "~/lib/graphql";

type Arg = {
  /** vodのseasonの型は共通, videoを入れる */
  node: ShelfOfPresetVideos["presetVideos"]["edges"][number]["node"];
  imageType?: G_VideoShelfImageType;
};

/** typenameに応じて値を生成する処理 */
export const generateVideoData = ({ node, imageType }: Arg) => {
  let miniDetailImgSrc = node.packageImage;
  let imgSrc = node.packageImage;
  let isSpotLive = false;

  switch (node.__typename) {
    case "VideoSeason": {
      const { keyVisualImage, keyVisualWithoutLogoImage, packageImage } = node;
      miniDetailImgSrc = keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      if (imageType !== undefined)
        imgSrc =
          imageType === G_VideoShelfImageType.Package
            ? packageImage
            : keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      break;
    }
    case "VideoStageSeason": {
      const { keyVisualImage, keyVisualWithoutLogoImage, packageImage } = node;
      miniDetailImgSrc = keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      if (imageType !== undefined)
        imgSrc =
          imageType === G_VideoShelfImageType.Package
            ? packageImage
            : keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      break;
    }
    case "VideoLegacySeason": {
      const { packageImage, packageLargeImage } = node;
      miniDetailImgSrc = packageLargeImage || packageImage;
      if (imageType !== undefined)
        imgSrc = imageType === G_VideoShelfImageType.Package ? packageImage : packageLargeImage || packageImage;
      break;
    }
    case "VideoSpotLiveSeason": {
      const { keyVisualImage, keyVisualWithoutLogoImage, packageImage } = node;
      miniDetailImgSrc = keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      isSpotLive = true;
      if (imageType !== undefined)
        imgSrc =
          imageType === G_VideoShelfImageType.Package
            ? packageImage
            : keyVisualImage || keyVisualWithoutLogoImage || packageImage;
      break;
    }
  }

  return {
    miniDetailImgSrc,
    imgSrc,
    isSpotLive,
  };
};
